var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-descriptions',{attrs:{"size":"small","bordered":""}},[_vm._l((_vm.valoresExpandidos),function(ve){return _c('a-descriptions-item',{attrs:{"label":ve.label}},[_vm._t(ve.column,[_vm._v("\n    "+_vm._s(_vm.detalle[ve.column])+"\n    ")],{"item":_vm.detalle[ve.column]})],2)}),_vm._v(" "),_vm._t("items")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b3be8b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/components/ui/DescriptionsDetail.vue
// module id = null
// module chunks = 